import { FolderOpen, List, Clock, Star, Share2, Bot } from 'lucide-react';

var VISTE = [
  { id: 'archivio',  label: 'Archivio',      icon: 'folder' },
  { id: 'lista',     label: 'Lista',         icon: 'list'   },
  { id: 'recenti',   label: 'Recenti',       icon: 'clock'  },
  { id: 'preferiti', label: 'Preferiti',     icon: 'star'   },
  { id: 'condivisi', label: 'Condivisi',     icon: 'share'  },
  { id: 'kb',        label: 'Assistente AI', icon: 'bot'    },
];

var ICONS = {
  folder: function() { return (<FolderOpen size={14} strokeWidth={2} />); },
  list: function() { return (<List size={14} strokeWidth={2} />); },
  clock: function() { return (<Clock size={14} strokeWidth={2} />); },
  star: function() { return (<Star size={14} strokeWidth={2} />); },
  share: function() { return (<Share2 size={14} strokeWidth={2} />); },
  bot: function() { return (<Bot size={14} strokeWidth={2} />); },
};

const tint = (c, pct) => `color-mix(in srgb, ${c} ${pct}%, transparent)`;

var styles = {
  nav: { display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 16px' },
  item: {
    display: 'flex', alignItems: 'center', gap: '6px',
    padding: '10px 18px', borderRadius: '20px',
    border: '0.5px solid transparent',
    cursor: 'pointer', fontSize: '13px', fontWeight: 500,
    color: 'var(--ds-muted)',
    background: 'transparent', outline: 'none', whiteSpace: 'nowrap',
    transition: 'background 150ms, color 150ms, border-color 150ms',
  },
  itemActive: { background: tint('var(--brand)', 12), color: 'var(--brand)', border: '0.5px solid var(--brand)' },
  separator: { width: '0.5px', height: '20px', background: 'var(--ds-border)', margin: '0 4px', flexShrink: 0 },
};

export default function MiniNav(props) {
  var vistaAttiva = props.vistaAttiva;
  var onCambiaVista = props.onCambiaVista;
  return (
    <nav style={styles.nav}>
      {VISTE.map(function(vista) {
        var isActive = vistaAttiva === vista.id;
        var IconComponent = ICONS[vista.icon];
        var itemStyle = Object.assign({}, styles.item, isActive ? styles.itemActive : {});
        var showSeparator = vista.id === 'condivisi';
        return (
          <span key={vista.id} style={{ display: 'flex', alignItems: 'center' }}>
            <button style={itemStyle} onClick={function() { onCambiaVista(vista.id); }}
              onMouseEnter={function(e) { if (!isActive) { e.currentTarget.style.background = 'var(--chip)'; } }}
              onMouseLeave={function(e) { if (!isActive) { e.currentTarget.style.background = 'transparent'; } }}
            >
              {IconComponent ? IconComponent() : null}
              {vista.label}
            </button>
            {showSeparator && <span style={styles.separator} />}
          </span>
        );
      })}
    </nav>
  );
}
